// extracted by mini-css-extract-plugin
module.exports = {"chromeframe":"PageNotFound_chromeframe__4AS59","pageContainer":"PageNotFound_pageContainer__1V6bt"};